export default __webpack_public_path__ + "static/media/ethereum.f5d80a53.svg";